import { FormProvider, useForm } from "react-hook-form";
import { SkillType } from "../../types";

import { ColorField } from "../common/form";

interface Props {
  onSubmit: (formData: any) => void;
  data?: SkillType;
}

export type FormData = {
  name: string;
  description: string;
  color: string; // RGBColor
};

const Form = ({ onSubmit, data }: Props) => {
  const methods = useForm<FormData>({ defaultValues: data });
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = methods;
  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)} id="slide-over-form">
        <div className="flex-1 flex flex-col justify-between">
          <div className="px-4 divide-y divide-gray-200 sm:px-6">
            <div className="space-y-6 pt-6 pb-5">
              <div className="space-y-1">
                <label
                  htmlFor="name"
                  className="block text-sm font-medium leading-5 text-gray-900"
                >
                  Name
                </label>
                <input
                  type="text"
                  id="name"
                  {...register("name", { required: true })}
                  className="mt-1 focus:ring-orange-500 focus:border-orange-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                />

                {errors.name && (
                  <span className="text-sm font-light text-red-500">
                    Name fehlt
                  </span>
                )}
              </div>
              <div className="space-y-1">
                <label
                  htmlFor="description"
                  className="block text-sm font-medium leading-5 text-gray-900"
                >
                  Beschreibung
                </label>
                <div className="mt-1">
                  <textarea
                    id="description"
                    {...register("description")}
                    className="shadow-sm focus:ring-orange-500 focus:border-orange-500 mt-1 block w-full sm:text-sm border-gray-300 rounded-md"
                  ></textarea>
                </div>
                <p className="mt-2 text-sm text-gray-500">
                  Kurze Beschreibung dieses Kompetenztyps
                </p>
              </div>
              <div className="space-y-2">
                <ColorField color={data?.color} />
              </div>
            </div>
          </div>
        </div>
      </form>
    </FormProvider>
  );
};

export default Form;
